var OplevMere = OplevMere || {};

OplevMere.socialFeed = OplevMere.socialFeed || function () {

    this.init = function() {
		runSocialFeed();
	};

	this.runSocialFeed = function(){
        var facebookAccount = $('.social-feed-list').attr('data-facebook-account');
        var facebookPostsNumber = $('.social-feed-list').attr('data-facebook-posts-number');
        var twitterAccount = $('.social-feed-list').attr('data-twitter-account');
        var twitterPostsNumber = $('.social-feed-list').attr('data-twitter-posts-number');
        

		 $('#js-social-feed-list').socialfeed({    
            // FACEBOOK
            facebook:{
                accounts: [facebookAccount],              //Array: Specify a list of accounts from which to pull wall posts
                limit: facebookPostsNumber,                                   //Integer: max number of posts to load
                access_token: '1773429932884049|klvbD1Phohx36qF4aKGtSVl8rDM'  //String: "APP_ID|APP_SECRET"
            },

            // TWITTER
            twitter:{
                accounts: [twitterAccount],              //Array: Specify a list of accounts from which to pull tweets
                limit: twitterPostsNumber,                                   //Integer: max number of tweets to load
                consumer_key: 'ZzowrmR9R0g8XXHntQq9XzlyP',          //String: consumer key. make sure to have your app read-only
                consumer_secret: 'D0AXdQEhIlY9EoAt3tB7O9XMZPgKjlZVN4wCaSrL3tFzJd5zAW',//String: consumer secret key. make sure to have your app read-only
            },

            // GENERAL SETTINGS
            length:80,                                      //Integer: For posts with text longer than this length, show an ellipsis.
            show_media:true,                                //Boolean: if false, doesn't display any post images
            update_period: 0,                               //Integer: Number of seconds before social-feed will attempt to load new posts.
            template_html:                                  //String: HTML used for each post. This overrides the 'template' filename option
            '<li class="social-feed-item"> \
            <div class="social-feed-item__link"> \
            <figure class="social-feed-item__media"> \
            <a href="{{=it.link}}" target="_blank"> \
            <img class="media-object" src="{{=it.author_picture}}"> \
            <svg class="icon social-feed-item__logo"> \
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#{{=it.social_network}}_color"></use> \
            </svg> \
            </a> \
            </figure> \
            <p class="social-feed-item__text">{{=it.text}}</p> \
            </div> \
            </li>',
            date_format: "ll",                              //String: Display format of the date attribute (see http://momentjs.com/docs/#/displaying/format/)
            moderation: function(content) {                 //Function: if returns false, template will have class hidden
                //console.log(content);
                return  (content.text) ? content.text.indexOf('fuck') == -1 : true;
            },
            callback: function() {                          //Function: This is a callback function which is evoked when all the posts are collected and displayed
                console.log("All posts collected!");
            }

            
        });
	};

    return {
		init : init,
		runSocialFeed : runSocialFeed
	};

}();